module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/photo_8@2x-7a20e22ad3de95bf35529dab2eb61817.jpg";